import { Facebook, Linkedin } from "lucide-react";
import { FACEBOOK_URL, LINKEDIN_URL } from "@/lib/site";

export default function FloatingSocials() {
  return (
    <div data-testid="floating-socials" className="fixed left-3 bottom-24 md:left-5 md:bottom-28 z-40 flex flex-col gap-2.5">
      <a
        href={FACEBOOK_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="social-float-facebook-link"
        aria-label="Like and follow Redeemer Solutions on Facebook"
        className="w-10 h-10 rounded-full bg-[#0D0D10]/90 border border-gold/30 flex items-center justify-center text-gold shadow-[0_8px_24px_rgba(0,0,0,0.5)] transition-colors hover:bg-gold hover:text-[#0A0A0C]"
      >
        <Facebook size={17} />
      </a>
      <a
        href={LINKEDIN_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="social-float-linkedin-link"
        aria-label="Follow Redeemer Solutions on LinkedIn"
        className="w-10 h-10 rounded-full bg-[#0D0D10]/90 border border-gold/30 flex items-center justify-center text-gold shadow-[0_8px_24px_rgba(0,0,0,0.5)] transition-colors hover:bg-gold hover:text-[#0A0A0C]"
      >
        <Linkedin size={17} />
      </a>
    </div>
  );
}
